import { BaseEditable } from '@fmcc-web-platform/react-components';
import React from 'react';
import { MarkerProps } from '../types/Tile';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const withEmptyMarker = (Component: React.FC<any>) => {
  const WrapperComponent = (props: { model: MarkerProps } & BaseEditable) => {
    if (!props.model || !props.model.markerUrl || !props.model.markerModule || !props.model.markerScope) {
      return <div />;
    }

    return <Component {...props} />;
  };
  WrapperComponent.displayName = `withEmptyMarker(${Component.displayName || Component.name})`;
  return WrapperComponent;
};

export default withEmptyMarker;
